<app-full-screen-popup [type]="'overlayPopup'"
  [workflowStatus]="workflowStatus"
  [workflowUser]="workflowUser"
  [formName]="'nomination'"
  [header]="'Competent Person/Qualified Person Nomination'"
  [yearCode]="yearCode"
  (onClose)="onCancel()"
  (onSubmitNomination)="onSubmitNomination()"
  (onEndorserReject)="onEndorserReject()"
  (onORCApprove)="onORCApprove()"
  (onEndorserApprove)="onEndorserApprove()"
  (rejectApplicant)="onRejectApplicant()"
  (rejectUpdateRequired)="onRejectUpdateRequired()">
  <app-section [type]="'overlayPopup'">
    <div class="display-body">
      <app-loader [hidden]="!showLoader"></app-loader>
      <app-alert [alert]="alert"></app-alert>
      <div class="nomination-detail" id="renderData"></div>
      <form [formGroup]="nominationFormGroupControl" *ngIf="nominationFormGroupControl">
        <div class="scope-width">
          <app-input-textarea
            [labelName]="'Area of Accountability'"
            [labelTextTransformNone]="true"
            [tooltiptxt]="'Enter comments to define all areas of Accountability covered as per CP report, cover page. Eg: Modelling & estimation, sampling and Assay, Reserve etc.'"
            [inputFormControl]="nominationFormGroupControl.controls.scope"
            [submitted]="submitNominationForm">
          </app-input-textarea>
        </div>
        <div>
          <app-input-checkbox [labelName]="'I have read and confirmed that the above information is correct'"
            [inputFormControl]="nominationFormGroupControl.controls.nominationTerm"
          ></app-input-checkbox>
            <div
            class="error"
            *ngIf="(nominationFormGroupControl?.controls?.nominationTerm &&
              (submitNominationForm || nominationFormGroupControl?.controls?.nominationTerm.touched) &&
              nominationFormGroupControl?.controls?.nominationTerm.errors) ||
              (nominationFormGroupControl?.controls?.nominationTerm &&
              nominationFormGroupControl?.controls?.nominationTerm.value === false)">
              Please read and confirm that the above information is correct.
           </div>
        </div>

        <div>
          <app-input-textbox [labelName]="'Signed in acceptance'"
            [inputFormControl]="nominationFormGroupControl.controls.signedAcceptance"></app-input-textbox>

          <app-input-textbox [labelName]="'Date'" [showDatePicker]="true" [placeHolder]="'DD/MM/YYYY'"
            [inputFormControl]="nominationFormGroupControl.controls.signedAcceptanceDate"></app-input-textbox>
        </div>

        <div>
          <app-input-textbox [labelName]="'Signed endorsement'"
            [inputFormControl]="nominationFormGroupControl.controls.signedEndorsement"></app-input-textbox>

          <app-input-textbox [labelName]="'Date'" [placeHolder]="'DD/MM/YYYY'" [showDatePicker]="true"
            [inputFormControl]="nominationFormGroupControl.controls.signedEndorsementDate"></app-input-textbox>
        </div>

        <div>
          <app-input-textbox [labelName]="'Signed approval'"
            [inputFormControl]="nominationFormGroupControl.controls.signedApproval"></app-input-textbox>

          <app-input-textbox [labelName]="'Date'" [showDatePicker]="true" [placeHolder]="'DD/MM/YYYY'"
            [inputFormControl]="nominationFormGroupControl.controls.signedApprovalDate"></app-input-textbox>
        </div>
      </form>
    </div>
  </app-section>
</app-full-screen-popup>

<app-pop-up *ngIf="showSubmitSuccessPopup">
  <app-pop-up-header
    [showSuccessIcon]="true"
    [headerName]="'Success'"
    (close)="goBackToCPNominations()"
  ></app-pop-up-header>

  <div class="comment">
    <span class="field-name">{{ successMessage }}</span>
  </div>

  <app-pop-up-footer>
    <app-button
      [name]="'Go to CP/QP Nominations'"
      [type]="'primary'"
      [textTransformNone]="true"
      (btnClick)="goBackToCPNominations()"
    ></app-button>
  </app-pop-up-footer>
</app-pop-up>

<app-pop-up *ngIf="showRejectedPopup" >
  <app-loader [hidden]="!showLoader"></app-loader>
  <app-pop-up-header [headerName]="'Reason for Rejection'" (close)="closeRejectionPopup()">
  </app-pop-up-header>
  <div class="comment" *ngIf="commentControl">
    <app-input-textarea
      [labelName]="'Please specify your reason for rejection'"
      [submitted]="submitCommentForm"
      [inputFormControl]="commentControl"
    >
    </app-input-textarea>
  </div>
  <app-pop-up-footer>
    <app-button
      [name]="'Cancel'"
      [type]="'outlined'"
      (btnClick)="closeRejectionPopup()"
    ></app-button>
    <app-button
      [name]="'Send'"
      [disable]="isReportingCycleLocked"
      [type]="'primary'"
      (btnClick)="confirmRejection()"
    ></app-button>
  </app-pop-up-footer>
</app-pop-up>
